/* eslint-disable */

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@saleor/components/Skeleton";
import React from "react";
import { FormattedMessage } from "react-intl";

import languageList from "@saleor/globalConstants.js";
import SingleSelectField from "@saleor/components/SingleSelectField";

const useStyles = makeStyles(
  theme => ({
    headerContainer: {
      marginBottom: theme.spacing(3)
    },
    pageHeader: {
      fontWeight: 600 as 600
    },
    subtitle: {
      color: theme.typography.caption.color
    },
    select: {
      "& .MuiSelect-select:focus": {
        backgroundColor: "rgba(0, 0, 0, 0);"
      },
      "& .MuiSelect-selectMenu": {
        height: "35px"
      },
      "& svg": {
        color: "#000"
      },
      "&:after, &:before, &:hover": {
        border: "none !important"
      }
    },
    root: {
      "&& fieldset": {
        borderColor: theme.palette.divider
      },
      marginRight: theme.spacing(2),
      width: 120,
      display: "inline-block",
      marginLeft: "5rem"
    }
  }),
  { name: "HomeHeader" }
);

interface HomeOrdersCardProps {
  userName: string;
  language: string;
  setLanguageHandle: (event: any) => void;
  disabled?: boolean;
  isSelect?: boolean;
}

const HomeOrdersCard: React.FC<HomeOrdersCardProps> = props => {
  const { userName, language, setLanguageHandle, disabled, isSelect } = props;

  const classes = useStyles(props);
  const shop_api_Name = localStorage.getItem("shop_api_Name");
  let shopNameList =
    languageList[shop_api_Name.substring(1, shop_api_Name.length - 1)];

  return (
    <div className={classes.headerContainer} data-test="home-header">
      <Typography
        className={classes.pageHeader}
        variant="h4"
        data-test="welcomeHeader"
      >
        {userName ? (
          <FormattedMessage
            defaultMessage="Hello there, {userName}"
            description="header"
            id="homeHeaderText"
            values={{
              userName
            }}
          />
        ) : (
          <Skeleton style={{ width: "10em" }} />
        )}

        {/* 第一次加载页面后再显示,切换时要显示 */}
        {shopNameList?.length && (!disabled || isSelect) && (
          <div className={classes.root}>
            <SingleSelectField
              choices={shopNameList}
              disabled={disabled}
              value={language}
              onChange={setLanguageHandle}
            />
          </div>
        )}
      </Typography>
      <Typography className={classes.subtitle}>
        {userName ? (
          <FormattedMessage
            defaultMessage="Here is some information we gathered about your store"
            description="subheader"
            id="homeHeaderTextCaption"
          />
        ) : (
          <Skeleton style={{ width: "10em" }} />
        )}
      </Typography>
    </div>
  );
};
HomeOrdersCard.displayName = "HomeOrdersCard";
export default HomeOrdersCard;
